import type { Mode, Workflow } from '../models/common.ts'
import { vPicklist } from '../validation/schema/core.ts'
import type { EquipmentAccessorial } from './accessorials.ts'
import type { EquipmentType } from './constants.ts'
import { equipmentTypes } from './equipment-types.ts'
import { flatbedEquipment } from './flatbed.ts'

export const flatbedEquipmentTypes: EquipmentType[] = flatbedEquipment.map(
  e => e.key,
)

export const isFlatbedEquipment = (equipmentType?: EquipmentType): boolean => {
  if (!equipmentType) return false
  return flatbedEquipmentTypes.includes(equipmentType)
}

export const displayEquipment = (equipmentType: EquipmentType): string => {
  return (
    equipmentTypes.find(e => e.key === equipmentType)?.name || equipmentType
  )
}

export const getEquipmentMode = (equipmentType: EquipmentType): Mode => {
  return equipmentTypes.find(e => e.key === equipmentType)?.mode
}

export const getEquivalentEquipmentTypes = (
  equipmentType: EquipmentType,
): EquipmentType[] => {
  const bucket = equipmentTypes.find(e => e.key === equipmentType)?.bucket

  if (!bucket) {
    return [equipmentType]
  }

  return equipmentTypes.filter(e => e.bucket === bucket).map(e => e.key)
}

export const vEquipmentType = (workflow?: Workflow) =>
  vPicklist(
    equipmentTypes
      .filter(e => !workflow || e.workflows?.includes(workflow))
      .map(e => e.key),
  )

export const favoriteTLEquipmentTypes: EquipmentType[] = [
  'dry-van-53',
  'dry-van-48',
  'flatbed-53',
  'flatbed-48',
  'refrigerated-48',
  'refrigerated-53',
]

export const validateEquipmentAccessorials = (
  loadEquipmentTypes: EquipmentType[],
  loadAccessorials: EquipmentAccessorial[],
): string[] => {
  const validAccessorials = equipmentTypes
    .filter(e => loadEquipmentTypes.includes(e.key))
    .flatMap(e => e.accessorialTypes)

  if (!loadAccessorials?.length) {
    return []
  }

  return loadAccessorials
    .filter(a => !validAccessorials.includes(a.key))
    .map(
      a =>
        `Accessorial "${a.key}" is incompatible with the provided equipment types.`,
    )
}
